import { createSelector } from 'reselect';

function createAvailableOptionsStringMap(allFields) {
  var toStringMap = new Map();
  var fromStringMap = new Map();
  if (allFields) {
    for (var i = 0; i < allFields.length; i++) {
      var _id = allFields[i].id;
      toStringMap.set(_id, _id.toString());
      fromStringMap.set(_id.toString(), _id);
    }
  }
  var toString = function toString(id) {
    return toStringMap.get(id);
  };
  var fromString = function fromString(id) {
    return fromStringMap.get(id);
  };
  return {
    toString: toString,
    fromString: fromString
  };
}
var createAvailableOptionsStringMapSelector = function createAvailableOptionsStringMapSelector() {
  return createSelector(function (props) {
    return props.allFields;
  }, function (allFields) {
    return createAvailableOptionsStringMap(allFields);
  });
};

export { createAvailableOptionsStringMapSelector };
//# sourceMappingURL=available-options-string-map-selector.esm.js.map
